import React, { ReactNode } from 'react';

interface OfferPageContainerProps {
  children: ReactNode;
}

const OfferPageContainer: React.FC<OfferPageContainerProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-white dark:bg-background">
      <div className="w-full px-4 sm:px-6 py-4 sm:py-8 max-w-3xl mx-auto">
        {children}
      </div>
    </div>
  );
};

export default OfferPageContainer;
